/**
 * Globaler Custom-Tooltip für data-tip Attribute.
 * Einmal initTooltip() aufrufen — reagiert auf alle [data-tip] Elemente.
 * Auf Touch-Geräten deaktiviert (Tooltips sind bei Touch nutzlos).
 */
import { isMobile } from './UITheme';

let initialized = false;

export function initTooltip(): void {
  if (initialized) return;
  initialized = true;

  if (isMobile()) return;

  const el = document.createElement('div');
  Object.assign(el.style, {
    position: 'fixed', pointerEvents: 'none', zIndex: '99999',
    background: 'rgba(5,8,18,0.95)', border: '1px solid rgba(136,204,255,0.2)',
    borderRadius: '6px', padding: '6px 12px', maxWidth: '320px',
    fontFamily: 'monospace', fontSize: '11px', color: '#8cf',
    display: 'none', whiteSpace: 'pre-line',
    boxShadow: '0 2px 12px rgba(0,0,0,0.5)',
  });
  document.body.appendChild(el);

  let active: Element | null = null;

  document.addEventListener('mouseover', (e) => {
    const t = (e.target as Element).closest?.('[data-tip]');
    if (!t || t === active) return;
    active = t;
    el.textContent = (t as HTMLElement).dataset.tip ?? '';
    el.style.display = 'block';
  });

  document.addEventListener('mouseout', (e) => {
    const t = (e.target as Element).closest?.('[data-tip]');
    if (t === active) { el.style.display = 'none'; active = null; }
  });

  document.addEventListener('mousemove', (e) => {
    if (!active) return;
    el.style.left = (e.clientX + 14) + 'px';
    el.style.top = (e.clientY - 10) + 'px';
  });
}
